import { ActionContext } from 'vuex';
import store from '@/store';
import { User, State } from '@/models/main';
import * as Sentry from '@sentry/vue';
import { timeZoneDefault } from '@/utils/PortalConstants';
import { format, utcToZonedTime } from 'date-fns-tz';

export interface ModuleUserState {
  user: User;
  userSelectedDates: string[];
}

export const moduleUser = {
  namespaced: true,
  state: {
    user: {
      customerCode: '',
      staff: false,
      username: '',
      avatar: '',
      email: '',
      first_name: '',
      last_name: '',
      phone_number: '',
      state: [],
      timezone: '',
      ref1_prompt: '',
      ref2_prompt: '',
      ref3_prompt: '',
    },
    userSelectedDates: [],
  },
  getters: {
    user: (state: ModuleUserState): User => state.user,
    isStaff: (state: ModuleUserState): boolean => state.user.staff,
  },
  actions: {
    async setUser({ commit }: ActionContext<ModuleUserState, State>, user: User): Promise<void> {
      commit('SET_USER', user);
    },
    async setUserDates({ commit }: ActionContext<ModuleUserState, State>, dates: string[]): Promise<void> {
      commit('SET_USER_DATE', dates);
    },
    async fetchUser({ commit }: ActionContext<ModuleUserState, State>, staff: boolean): Promise<void> {
      const authData = store.getters['moduleAuthData/authData'];
      const userFromToken = {
        username: authData.name,
        customerCode: authData.customerCode,
        staff,
      };
      commit('SET_USER', userFromToken);
    },
    async removeUser({ commit }: ActionContext<ModuleUserState, State>): Promise<void> {
      commit('REMOVE_USER_DATA');
    },
  },
  mutations: {
    SET_USER(state: ModuleUserState, user: User): void {
      state.user = { ...state.user, ...user };
      const userData = {
        username: state.user.username,
        staff: state.user.staff,
        customerCode: state.user.customerCode,
      };
      Sentry.setUser(userData);
    },
    SET_USER_DATE(state: ModuleUserState, dates: string[]): void {
      if (dates) {
        state.userSelectedDates = [];
        const dateFrom = dates[0] ? new Date(dates[0]) : new Date();
        state.userSelectedDates[0] = format(
          utcToZonedTime(dateFrom, state.user.timezone || timeZoneDefault),
          'yyyy-MM-dd',
        );
        if (dates && dates[1]) {
          state.userSelectedDates[1] = format(
            utcToZonedTime(new Date(dates[1]), state.user.timezone || timeZoneDefault),
            'yyyy-MM-dd',
          );
        }
      }
    },
    REMOVE_USER_DATA(state: ModuleUserState): void {
      state.user = {} as User;
      Sentry.setUser(null);
    },
  },
};
